// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as LocaleDataType$OrcaPaymentPage from "../../shared-code/sdk-utils/types/LocaleDataType.bs.js";

function toValidationLocale(webLocale) {
  var newrecord = Caml_obj.obj_dup(LocaleDataType$OrcaPaymentPage.defaultLocale);
  newrecord.mandatoryFieldText = webLocale.mandatoryFieldText;
  newrecord.unsupportedCardErrorText = webLocale.cardNotEligibleText;
  newrecord.invalidNickNameError = webLocale.invalidNickNameError;
  newrecord.pixKeyEmptyText = webLocale.pixKeyEmptyText;
  newrecord.pixCPFEmptyText = webLocale.pixCPFEmptyText;
  newrecord.pixCPFInvalidText = webLocale.pixCPFInvalidText;
  newrecord.pixCNPJEmptyText = webLocale.pixCNPJEmptyText;
  newrecord.pixCNPJInvalidText = webLocale.pixCNPJInvalidText;
  newrecord.formFieldInvalidRoutingNumber = webLocale.formFieldInvalidRoutingNumber;
  newrecord.dateOfBirthInvalidText = webLocale.dateOfBirthInvalidText;
  newrecord.dateofBirthRequiredText = webLocale.dateofBirthRequiredText;
  newrecord.vpaIdInvalidText = webLocale.vpaIdInvalidText;
  newrecord.vpaIdEmptyText = webLocale.vpaIdEmptyText;
  newrecord.blikCodeInvalidText = webLocale.blikCodeInvalidText;
  newrecord.phoneInvalidText = webLocale.phoneInvalidText;
  newrecord.accountNumberInvalidText = webLocale.accountNumberInvalidText;
  newrecord.ibanEmptyText = webLocale.ibanEmptyText;
  newrecord.postalCodeInvalidText = webLocale.postalCodeInvalidText;
  newrecord.lastNameRequiredText = webLocale.lastNameRequiredText;
  newrecord.invalidDigitsCardHolderNameError = webLocale.invalidCardHolderNameError;
  newrecord.cardHolderNameRequiredText = webLocale.cardHolderNameRequiredText;
  newrecord.enterValidDetailsText = webLocale.enterValidDetailsText;
  newrecord.cvcNumberEmptyText = webLocale.cvcNumberEmptyText;
  newrecord.cardExpiryDateEmptyText = webLocale.cardExpiryDateEmptyText;
  newrecord.cardNumberEmptyText = webLocale.cardNumberEmptyText;
  newrecord.emailEmptyText = webLocale.emailEmptyText;
  newrecord.emailInvalidText = webLocale.emailInvalidText;
  newrecord.inValidExpiryErrorText = webLocale.inValidExpiryErrorText;
  newrecord.inValidCVCErrorText = webLocale.inCompleteCVCErrorText;
  newrecord.inValidCardErrorText = webLocale.inValidCardErrorText;
  return newrecord;
}

export {
  toValidationLocale ,
}
/* No side effect */
